var $ = require('jquery');
var features = require('diy/util/features');

/* globals diy, script_basisID */
$(function () {

    //if chat feature is not available just return.
    if (!features('chatNotification')) {
        return;
    }
    var DISPLAY_DELAY = 120,
        countingCookie,
        COUNTING_COOKIE_NAME = 'diy-chatnotification-counting-' + script_basisID;

    if ($.cookie(COUNTING_COOKIE_NAME) === 'consumed') {
        return;
    }
    // create a start counting cookie //
    countingCookie = $.cookie(COUNTING_COOKIE_NAME);
    if (!countingCookie) {
        $.cookie(COUNTING_COOKIE_NAME, (new Date()).getTime() / 1000, {path: '/'});
    }

    // check the cookie until it's time to show the chat bar //
    setTimeout(function () {

        // put the cookie on shown - to not show again in this session //
        $.cookie(COUNTING_COOKIE_NAME, 'consumed', {path: '/'});

        // create chat notification when the time is right //
        var notifications = diy.editor.notifications;
        notifications.api.ready(function() {
            var noChatNotifications = notifications.api.getNotificationsByType(notifications.Notifications.TYPE_CHAT);
            if (noChatNotifications.length <= 0) {
                notifications.api.createNotification({type: notifications.Notifications.TYPE_CHAT});
            }
        });

    }, Math.max(
        ( DISPLAY_DELAY - ( ((new Date()).getTime() / 1000) - $.cookie(COUNTING_COOKIE_NAME) ) ) * 1000,
        0
    ));
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/chatnotification.js
 ** module id = 671
 ** module chunks = 0
 **/